<template>
    <div>
        <navbar :title="fad" :box="box"/>

      <div style="margin-top:5px">
      <van-card v-for="(items,index) in posts" :key="index" @click="remove(index,items.ad)"
        :num="items.adet+' Adet'"
        :price="parabirimi(items.fiyat * items.adet)"
        :title="items.isim"
        :desc="items.puan * items.adet+' QV'+' - '+items.adet * items.kpuan+' KP'"
        class="goods-card"
        :currency="''"
        :thumb="'https://ayurlifeworld.com/upload/'+items.foto"
      />
      </div>

      <van-grid :column-num="3">
        <van-grid-item icon="fire-o" :text="parabirimi(total)" />
        <van-grid-item icon="award-o" :text="qv+ ' QV'" />
        <van-grid-item icon="coupon-o" :text="kp+ ' KP'" />
      </van-grid>

      <van-button @click="sipekle()" v-if="total>0"  size="large" color="#f00" plain>  SİPARİŞ VER  </van-button>
       <van-divider v-else>Sepetinizde ürün bulunmamaktadır.</van-divider>   

      <van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>
    </div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import { Dialog } from 'vant';
import { Notify } from 'vant';
import {router}  from '@/router';
import navbar from './nav'
export default {
  components:{
    navbar
  },
  data() {
    return {
      tab2:0,
      posts:[],
      sepet:'',
      show:false,
      active:'Sepet',
      fad:'Sepet',
      box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0
    };
  },
    computed: {
    total() {
      return this.posts.reduce(
        (acc, item) => acc + item.fiyat * item.adet,
        0
      );
    },
    kp() {
      return this.posts.reduce(
        (acc, item) => acc + item.kpuan * item.adet,
        0
      );
    },   
    qv() {
      return this.posts.reduce(
        (acc, item) => acc + item.puan * item.adet,
        0
      );
    },     
  }, 
  created (){
  this.show = true
   userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {this.getProduct()})
    .catch(err => {userService.logout()})
  },
    methods : {
      sipekle(){
        router.push('/pays')
          // Dialog.confirm({
          // title: 'Onaylıyor musunuz ?',
          // message:'Sipariş eklenecek',
          // })
          //   .then(() => {
                
          //   })
      },
      getProduct(){
        JSON.parse(localStorage.getItem('ayuBox')).baskets.forEach(element => {
          helper.request.get('urunler/'+element.id)
          .then(res =>{
               this.posts.push(
                  {
                    isim : res.results[0].ad,
                    //fiyat:helper.funcs.kdv(res.results[0].fiyat,res.results[0].kdv),
                   // miktar:res[0].eldeki_miktar, stok kontrol yok
                   fiyat:res.results[0].fiyat,
                    skod:res.results[0].kod,
                   // kdv:res.results[0].kdv,
                    puan:res.results[0].puan,
                    kpuan:res.results[0].kariyer_puan,
                    indirim:res.results[0].indirim,
                    foto:res.results[0].foto,
                    adet:element.adet,
                    id:element.id
                  }
                )
          })
          .catch(err => {Notify({ type: 'danger', message: err.message });})
          
        });
        this.show = false
      },
      parabirimi(res){
        return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(res).replace("€","TL")
      },
      // stokkontrol(adet,miktar){
      //   if (miktar >= adet){ return "Stok müsait"}
      //   else{ return "Stok müsait değil" }
      // },      
      remove (index,isim) {
          Dialog.confirm({
          title: isim,
          message:'Sepetten silinecek ?',
          })
            .then(() => {
              this.show = true
                var items = JSON.parse(localStorage.getItem('ayuBox')) || [];
                items.baskets.splice(index,1)
                localStorage.setItem('ayuBox', JSON.stringify(items))
                this.posts.splice(index,1)
                this.show = false
                this.box--
                Notify({ type: 'success', message: 'İşlem Başarılı' });
            })
            .catch(() => {Notify({ type: 'danger', message: 'Ürün Sepette Bekliyor' })})
            
      },

   
  } 
};
</script>
<style>
  .para{font-size: 24px;}
  .delete-button {
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/sepet.vue